import { PollDrawer, SSPollContent, SSPollToggleButton } from '@core/poll';
import { useAppSelector } from '@online-webinar/store';
import { useEffect, useId, useState } from 'react';

export const PollContainer = ({ isOnDemand, isLandscape, mobileMenuEnabled }: { isOnDemand: boolean; isLandscape: boolean; mobileMenuEnabled: boolean }) => {
    const activePoll = useAppSelector((state) => (isOnDemand ? state.onDemandWebinar.activePoll : state.liveWebinar.activePoll));
    const activePollStatus = useAppSelector((state) => (isOnDemand ? state.onDemandWebinar.activePollStatus : state.liveWebinar.activePollStatus));
    const myPollVotes = useAppSelector((state) => (isOnDemand ? state.onDemandWebinar.myPollVotes : state.liveWebinar.myPollVotes));

    const [hasVotedOnPoll, setHasVotedOnPoll] = useState(false);
    const [showPollDrawer, setShowPollDrawer] = useState(true);
    const onPollToggleButtonClick = () => setShowPollDrawer(!showPollDrawer);
    const pollContentId = useId();

    useEffect(() => {
        setShowPollDrawer(!!activePoll);
        setHasVotedOnPoll(myPollVotes.some((vote) => vote.pollId === activePoll?.pollId));
    }, [activePoll, myPollVotes]);

    if (!activePoll || !activePollStatus) {
        return <></>;
    }

    return (
        <PollDrawer activePollStatus={activePollStatus} isLandscape={isLandscape} isMobile={mobileMenuEnabled}>
            <SSPollToggleButton shown={showPollDrawer} onClick={onPollToggleButtonClick} contentId={pollContentId} />
            <SSPollContent
                id={pollContentId}
                shown={showPollDrawer}
                hasVotedOnPoll={hasVotedOnPoll}
                activePoll={activePoll}
                activePollStatus={activePollStatus}
                isOnDemand={isOnDemand}
            />
        </PollDrawer>
    );
};
